import { gql } from '@apollo/client';

export const GET_TOP_GEAR_TYPES = gql`
  query GetTopGearTypes($filters: DistributionGraphsInput) {
    getTopGearTypes(input: $filters) {
      amountOfListings
      label
    }
  }
`;
